class config {
  constructor(name, description, valueCorr, valueDeff) {
    this.name = name;
    this.description = description;
    this.valueCorr = valueCorr;
    this.valueDeff = valueDeff;
  }
  static fromJson({ cfgNombre, descripcion, valorCorr, valorDef }) {
    return new config(cfgNombre, descripcion, valorCorr, valorDef);
  }
}
export default config;
